import jwtAuthAxios from "./auth/jwtAuth";

// Portal "Mis pedidos" del perfil Cliente. Ver hermes-backend Api::V1::ClientPortalController.
const clientPortalServices = {};

clientPortalServices.getShipments = async (params = {}) => {
    const { data } = await jwtAuthAxios.get('/client_portal/shipments', { params });
    return data;
};

// `kind` es "delivery" u "order": los ids de entregas y pedidos se pisan.
clientPortalServices.getShipment = async (kind, id) => {
    const { data } = await jwtAuthAxios.get(`/client_portal/shipments/${kind}/${id}`);
    return data;
};

export default clientPortalServices;
